export const getRealTimeApi = (state) => state.realTimeReducer.real_time;
export const isSuccess = (state) => state.realTimeReducer.isSuccess;
export const isLoading = (state) => state.realTimeReducer.isLoading;
export const isError = (state) => state.realTimeReducer.isError;
